<template>
  <div>
    <a-page-header class="vd-gl-header-warp">
      <template slot="footer">
        <a-tabs :default-active-key="$route.path" @change="changePane">
          <a-tab-pane
            v-show="$AuthUtil.authRoute('/qq/detail/member')"
            key="/qq/detail/member"
            tab="成员列表"
          />
        </a-tabs>
      </template>
      <a-descriptions size="small" :column="1">
        <a-descriptions-item label="群名">
          {{ detail.group_name }}
        </a-descriptions-item>
        <a-descriptions-item label="群号">
          {{ detail.group_qq }}
        </a-descriptions-item>
        <a-descriptions-item label="群主">
          {{ detail.owner_qq }}
        </a-descriptions-item>
        <a-descriptions-item label="群人数上限">
          {{ detail.num_max }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">
          {{ $FormatUtil.timestamp2date(detail.add_time) }}
        </a-descriptions-item>
        <template v-if="detail.delete_time !== 0">
          <a-descriptions-item label="解散时间">
            {{ $FormatUtil.timestamp2date(detail.delete_time) }}
          </a-descriptions-item>
        </template>
      </a-descriptions>

      <div class="vd-gl-statistic-group">
        <a-statistic
          title="群状态"
          :value="detail.delete_time === 0 ? '正常' : '解散'"
          class="vd-gl-statistic"
        />
        <a-statistic title="群成员" :value="detail.num" class="vd-gl-statistic">
          <template slot="prefix">
            <a-icon type="user"></a-icon>
          </template>
        </a-statistic>
        <!-- 推广总量 -->
        <a-statistic
          title="今日消息数"
          :value="detail.message"
          class="vd-gl-statistic"
        />
      </div>
    </a-page-header>

    <div class="vd-gl-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { get_group_detail } from '@/api/qq'

export default {
  name: 'Detail',
  data() {
    return {
      id: undefined,
      detail: {
        group_name: '- -',
        group_qq: '- -',
        owner_qq: '- -',
        num_max: '- -',
        add_time: '- -',
        delete_time: 0,
        num: '- -',
        message: '- -',
      },
    }
  },
  created() {
    let query = this.$route.query
    this.id = parseInt(query.id)
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      get_group_detail({
        id: this.id,
      }).then((res) => {
        if (res['code'] === 1) {
          console.log(res)
          this.detail.group_name = res.data.group_name
          this.detail.group_qq = res.data.group_qq
          this.detail.owner_qq = res.data.owner_qq
          this.detail.num_max = res.data.num_max
          this.detail.add_time = res.data.add_time
          this.detail.delete_time = res.data.delete_time
          this.detail.num = res.data.num
          this.detail.message = res.now_day_message
        } else {
          this.$message.warning({
            content: res['msg'],
            key: 'get_group_detail',
          })
        }
      })
    },
    // 跳转
    changePane(value) {
      // 判断参数是否正确
      if (this.id) {
        this.$router.replace({ path: value, query: { id: this.id } })
      } else {
        this.$message.error({ content: '访问参数错误' })
        // 链接回跳
        this.$router.replace({ path: '/program/setting', replace: true })
        return false
      }
    },
  },
}
</script>

<style scoped></style>
